export default __webpack_public_path__ + "static/media/df064c07c1f24331a1b8919a034434c51600804047569.1fbefda2.webp";